<div class="hidden md:block">
  <p
    class="max-w-15rem ng-star-inserted overflow-hidden text-overflow-ellipsis"
    *ngIf="hasOrganization$ | async; else noCurrentOrganization"
  >
    {{ organizationName$ | async }}
  </p>
  <ng-template #noCurrentOrganization>{{ 'Iam.OrganizationSwitch.Fields.NoneIsCurrent' | translate }}</ng-template>
</div>
